<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong>User BMI</strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="getStd()"
                        persistent-hint hint="Select academic year" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="display_name" item-value="id" label="Semester" persistent-hint hint="Select semester"
                        @click="putallnull()" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv();"
                        persistent-hint hint="Select standard" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" item-value="div_off_id"
                        :items="div_list" item-text="div_name" label="Division" outlined persistent-hint
                        hint="Select division" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sel_std_data && div">
                    <v-btn class="mt-6 button" @click="getreport()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12" v-if="bmilist != ''">
                <v-row dense>
                    <v-col class="pb-2" cols="12" sm="6" md="6">
                        <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'UserBMI')"
                            :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="12" sm="6" md="6" class="pb-2 d-flex justify-end">
                        <v-btn rounded color="success" small tile @click="openFileSelector()">
                            <v-icon class="mr-2" small>mdi-file-import</v-icon>
                            Import BMI
                        </v-btn>
                    </v-col>
                </v-row>
                <div id="my-table-id">
                    <div class="scroll">
                        <v-simple-table fixed-header dense class="elevation-1" height="500px">
                            <thead>
                                <tr>
                                    <th class="">
                                        <center>Sr. No.</center>
                                    </th>
                                    <th class="">
                                        <center>Roll No.</center>
                                    </th>
                                    <th class="">
                                        <center>Registration No.</center>
                                    </th>
                                    <th class="">
                                        <center>Name</center>
                                    </th>
                                    <th class="">
                                        <center>Height (centimeter)</center>
                                    </th>
                                    <th class="">
                                        <center>Weight (Kg)</center>
                                    </th>
                                    <th class="">
                                        <center>BMI</center>
                                    </th>
                                    <th class="">
                                        <center>Save BMI</center>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(s, index) in bmilist" :key="s.lid">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ s.rollno }}</td>
                                    <td>{{ s.registration_number }}</td>
                                    <td>{{ s.name }}</td>
                                    <td>
                                        <input placeholder="Enter Height(cm)." class="input text-center" type="number"
                                            v-model="s.height" :name="s.lid"
                                            :rules="[v => !!v || 'Required' || v >= 0]" />
                                    </td>
                                    <td>
                                        <input placeholder="Enter Weight(Kg)." class="input text-center" type="number"
                                            v-model="s.weight" :name="s.lid"
                                            @change="get_bmi(s.height, s.weight, s.lid)"
                                            :rules="[v => !!v || 'Required' || v >= 0]" />
                                    </td>
                                    <!-- <td><input class="input text-center" type="number" v-model="s.bmi" :name="s.lid" :onkeypress="isNumber(s.bmi)" :rules="[v => !!v || 'Required' || v >= 0]" /></td> -->
                                    <td><input class="input text-center" type="number" v-model="s.bmi" :name="s.lid"
                                            :rules="[v => !!v || 'Required' || v >= 0]" /></td>
                                    <td><v-btn rounded small outlined color="primary"
                                            @click="save_bmi(s.height, s.weight, s.bmi, s.lid)"
                                            :loading="fetch_loader">Save
                                            BMI</v-btn></td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <br />
                        <div style="text-align:center;">
                            <v-btn rounded outlined color="primary" @click="saveAllBMI()" :loading="fetch_loader">Save
                                All
                                BMI's</v-btn>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-card>
        <v-dialog v-model="import_dialog" max-width="500px">
        <v-card>
            <v-card-title>
            <!-- <span class="headline mb-5">Import BMI</span> -->
            <v-spacer></v-spacer>
            <v-btn small color="success" @click="generateExcel" class="mb-5">
            Download Excel Template
            </v-btn>
            </v-card-title>

            <v-card-text>
            <v-file-input
                v-model="file"
                label="Select BMI CSV File"
                prepend-icon="mdi-file"
                outlined
                rounded
                dense
                show-size
            ></v-file-input>
            </v-card-text>

            <v-card-actions class="justify-center">
            <v-btn color="blue darken-1" text @click="import_dialog = false">Cancel</v-btn>
            <v-btn color="primary darken-1" @click="importBMI" :disabled="!file">Submit</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import axios from "axios";
import * as XLSX from 'xlsx'
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        overlay: false,
        valid: false,
        errorMsg: {},
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
        search: "",
        snackbar_msg: "",
        color: "",
        snackbar: false,
        uid_domain: "",
        fetch_loader: false,
        dialog: false,
        userlist: {},
        usertype: {},
        ay_std_div_list: null,
        sel_ay_data: null,
        std_div_list: null,
        sel_std_data: null,
        div_list: null,
        div: null,
        semester_list: null,
        sem: null,
        table_fields: {
            RollNo: "rollno",
            Registration_number: "registration_number",
            Name: "name",
            Height: "height",
            Weight: "weight",
            Bmi: "bmi",
        },
        standardlist: "",
        
        bmilist: "",
        file : null,
        import_dialog : false,
        fieldNames: ["PRN No","Height","Weight"]
    }),
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New BMI Calculation" : "Edit BMI Calculation";
        },
    },
    watch: {
        dialog(val) {
            val || this.close();
        },
    },
    mounted() {
        this.onLoad();
    },
    methods: {
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>" + name + "</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";

            tab_text = tab_text + "<tr>";
            tab_text = tab_text + "<th>SR. No.</th>";
            tab_text = tab_text + "<th>Roll No.</th>";
            tab_text = tab_text + "<th>Registration No.</th>";
            tab_text = tab_text + "<th>Name</th>";
            tab_text = tab_text + "<th>Height (centimeter)</th>";
            tab_text = tab_text + "<th>Weight (Kg)</th>";
            tab_text = tab_text + "<th>BMI</th>";
            tab_text = tab_text + "<th>Save BMI</th>";
            tab_text = tab_text + "</tr>";


            this.bmilist.forEach((s, index) => {
                tab_text = tab_text + "<tr>";
                tab_text = tab_text + "<td>" + (index + 1) + "</td>";
                tab_text = tab_text + "<td>" + s.rollno + "</td>";
                tab_text = tab_text + "<td>" + s.registration_number + "</td>";
                tab_text = tab_text + "<td>" + s.name + "</td>";
                tab_text = tab_text + "<td>" + s.height + "</td>";
                tab_text = tab_text + "<td>" + s.weight + "</td>";
                tab_text = tab_text + "<td>" + s.bmi + "</td>";
                tab_text = tab_text + "<td></td>";
                tab_text = tab_text + "</tr>";
            });

            tab_text = tab_text + "</table></body></html>";

            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            // Save the file
            const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        openFileSelector() {
            this.import_dialog = true;
        },
        generateExcel() {
            try {
            const dataForSheet = [this.fieldNames];
            const worksheet = XLSX.utils.aoa_to_sheet(dataForSheet);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Bulk Import BMI");
            const wscols = this.fieldNames.map(() => ({ wch: 20 }));
            worksheet['!cols'] = wscols;
            XLSX.writeFile(workbook, "BMI_Import_Template.xlsx");
            
            } catch (error) {
            console.error("Error generating Excel:", error);
            alert("Failed to generate Excel file.");
            }
        },

        importBMI() {
            if (!this.file) {
                this.showSnackbar("#b71c1c", "Please select a file!");
                return;
            }

            const formData = new FormData();
            formData.append("file", this.file);
            formData.append("ay",this.sel_ay_data.ay_id)
            formData.append("standard",this.sel_std_data.std_id)
            formData.append("sem",this.sem)
            formData.append("div",this.div)

            this.overlay = true;
            axios.post("/Examination/importBMI", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
                })
                .then((res) => {
                if (res.data.status === "SUCCESS") {
                    this.showSnackbar("#4caf50", res.data.snackbar);
                    this.getreport();
                } else {
                    this.showSnackbar("#b71c1c", res.data.snackbar);
                }
                this.import_dialog = false;
                this.file = null;
            })
            .catch((error) => {
                console.error("Import failed:", error);
                this.showSnackbar("#b71c1c", "Something went wrong!");
            })
            .finally(() => {
                this.overlay = false;
            });
        },
        saveAllBMI() {
            const array = [];
            for (var i = 0; i < this.bmilist.length; i++) {
                array.push(this.bmilist[i])
            }
            const data = {
                ay: this.sel_ay_data.ay_id,
                standard: this.sel_std_data.std_id,
                sem: this.sem,
                div: this.div,
                array: array
            };
            axios
                .post("/Examination/saveAllBMICalculations", data)
                .then((res) => {
                    if (res.data.code == "SUCCESS") {
                        this.showSnackbar("#4caf50", "All BMI's are saved..."); // show snackbar
                        this.fetch_loader = false;
                        this.onLoad();
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.fetch_loader = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                    this.fetch_loader = false;
                })
                .finally(() => {
                    this.fetch_loader = false;
                });
        },
        putallnull() {
            this.div_list = null;
        },
        save_bmi(height, weight, bmi, lid) {
            if (height == "" || weight == "") {
                this.showSnackbar("#b71c1c", "Please enter weight / height values!"); // show snackbar
                return
            }
            const data = {
                height: height,
                weight: weight,
                bmi: bmi,
                lid: lid,
                ay: this.sel_ay_data.ay_id,
                standard: this.sel_std_data.std_id,
                sem: this.sem,
                div: this.div,
            };
            this.fetch_loader = true;
            axios
                .post("/Examination/saveBMICalculation", data)
                .then((res) => {
                    if (res.data.code == "SUCCESS") {
                        this.showSnackbar("#4caf50", res.data.msg); // show snackbar
                        this.fetch_loader = false;
                        this.onLoad();
                    } else if (res.data.code == "NA") {
                        this.showSnackbar("#b71c1c", res.data.msg); // show snackbar
                        this.fetch_loader = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                    this.fetch_loader = false;
                })
                .finally(() => {
                    this.fetch_loader = false;
                });
        },
        getreport() {
            const data = {
                ay: this.sel_ay_data.ay_id,
                standard: this.sel_std_data.std_id,
                sem: this.sem,
                div: this.div,
            };
            this.fetch_loader = true;
            axios
                .post("/Examination/bmiCalculationHome", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.bmilist = res.data.bmilist;
                        this.fetch_loader = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                    this.fetch_loader = false;
                })
                .finally(() => {
                    "use strict";
                    this.fetch_loader = false;
                });
        },
        getStd() {
            this.std_div_list = null;
            this.sel_std_data = null;
            this.div_list = null;
            this.div = null;
            this.std_div_list = this.sel_ay_data.std_list;
        },
        getDiv() {
            // this.div_list = ["All"];
            // this.div = "All";
            this.div_list = this.sel_std_data.div_list;
            // this.div_list.unshift("All");
            // this.div = this.div_list[0];
            if (this.div_list.length == 0) {
                alert("No division found!!!");
                this.div_list = null;
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/commonAPI/get_ay_std_div")
                .then((res) => {
                    this.overlay = false;
                    this.ay_std_div_list = res.data.data;
                    //     this.sel_ay_data = res.data.curr_ay;
                    this.semester_list = res.data.sem_list;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        // isNumber(value){
        //     if (isNaN(value)) {
        //         this.showSnackbar("#b71c1c", "Please enter only numbers"); // show snackbar
        //         return
        //     } 
        // },
        // isNumber(evaluated_marks) {
        //     var iKeyCode = evaluated_marks.which ? evaluated_marks.which : evaluated_marks.keyCode;
        //     if (iKeyCode != 46 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57)) return false;
        //     return true;
        // },
        get_bmi(height, weight, lid) {
            // console.log("inside this.get_bmi")
            // console.log("height "+height+"weight "+weight+"lid "+lid)
            let conversion = height / 100
            let sq_height = conversion * conversion
            let bmi = weight / sq_height
            for (var i = 0; i < this.bmilist.length; i++) {
                // alert("in for"+lid+"12345678"+this.bmilist[i].lid)
                if (lid == this.bmilist[i].lid) {
                    // alert("in if")
                    this.bmilist[i].bmi = bmi
                    //  alert(bmi)
                }
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        save() {
            axios
                .post("/Examination/saveBMICalculation")
                .then((res) => {
                    // if (res.data.msg == "200") {
                    //     this.onLoad();
                    //     this.showSnackbar("#4caf50", "New BMI calculation added Successfully..."); // show snackbar on success
                    // } else if (res.data.msg == "300") {
                    //     this.showSnackbar("#4caf50", res.data.description); // show snackbar on success
                    // }
                })
                .catch((error) => {
                    window.console.log(error);
                    this.showSnackbar("#b71c1c", "Something went wrong!!!"); // show snackbar on success
                });
            this.close();
        },
    },
};
//};
</script>
<style scoped>
.slide {
    color: red;
    font-weight: bold;
    margin-left: 10px;
}

.scroll {
    overflow-x: scroll;
}

.box {
    background-color: white !important;
    margin: 8px !important;
    padding: 8px;
    border: 2px solid #0f2027 !important;
}

/* .button {
        border: 2px solid #0f2027 !important;
        color: #0f2027;
        background: transparent !important;
        border-radius: 50px;
        margin: 0.5rem !important;
    } */
.button:hover {
    color: white;
    background: #0f2027 !important;
    background: #0f2027;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.mytable /deep/ thead th {
    background: #0f2027;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.btn-css {
    outline: 0 !important;
    outline-offset: 0 !important;
    background-image: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background-color: #fff !important;
    text-decoration: underline;
    color: #0f2027 !important;
    text-align: left;
}

.btn-css:hover {
    outline: 0 !important;
    outline-offset: 0 !important;
    background-image: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background-color: #ffff !important;
    color: #0f2027 !important;
    text-decoration: underline;
    text-align: left;
}

input[type="number"] {
    width: 50%;
    display: inline-block;
    border: 1px solid black;
    border-radius: 4px;
    box-sizing: border-box;
}

tr,
td,
th {
    border: 1px solid #ccc;
    text-align: center;
    font-size: small;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
    font-size: small;
}

td {
    margin: 0rem !important;
    padding: 0rem !important;
    font-size: small;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
    font-size: small;
}
</style>

